<template>
    <v-form ref="form" v-model="valid" :class="{recover: token}" class="form-component">
        <h3>{{title}}</h3>
        <br>
        <v-container class="pa-0">
            <v-layout row>
                <v-flex xs4>
                    <v-text-field class="lance"
                        v-if="!token"
                        v-model="model.password"
                        label="Contraseña"
                        type="password"
                        :rules="[v => !!v || 'Campo requerido']"
                    ></v-text-field>
                </v-flex>
                <v-flex xs4>
                    <v-text-field class="lance"
                        v-model="model.newPassword"
                        label="Nueva Contraseña"
                        type="password"
                        :rules="[v => !!v || 'Campo requerido']"
                    ></v-text-field>
                </v-flex>
                <v-flex xs4>
                    <v-text-field class="lance"
                        v-model="model.confirmPassword"
                        label="Confirmar Contraseña"
                        type="password"
                        :rules="[
                            v => !!v || 'Campo requerido', 
                            v => v === model.newPassword || 'Contraseña no coincide'
                        ]"
                    ></v-text-field>
                </v-flex>
            </v-layout>
            <v-layout row wrap>
                <v-flex xs12 md4>
                    <v-btn color="submitBtn" solo :disabled="!valid || sending" @click="token? recoverPassword(): save()">Guardar</v-btn>
                </v-flex>
            </v-layout>
        </v-container>
        <br>
    </v-form>
</template>



<script>
    import { events } from '../main';
    export default {
        name: 'changepassword',
        data() {
            return {
                title: "",
                token: null,
                id: localStorage.getItem('userId'),
                valid: true,
                model: {},
                sending: false
            }
        },
        methods: {
            snackbar: function(message) {
                events.$emit('snackbar', message);            
            },
            // password change with current password
            save() {
                if (this.$refs.form.validate()) {
                    this.sending = true;                                        
                    this.$http.put('user/changepassword/' + this.id, this.model)
                        .then((response) => {
                            this.snackbar('Registro actualizado con éxito');
                            this.$router.push('/');                                
                        }, error => {
                            this.sending = false;                                
                            var message = error.body.msg || 'Error al actualizar registro';
                            this.form = {};
                            this.snackbar(message);
                            console.error(error);
                    });
                }
            },
            // password recovery via email
            validateToken() {
                this.$http.post(`login/validatetoken/${this.token}`).then(response => {}).catch( error => {
                    this.snackbar("El link es invalido.");
                    this.$router.push("/login");
                });
            },
            recoverPassword() {
                this.$http.put("login/recoverpassword/" + this.token, {newPassword: this.model.newPassword})
                .then(response => {
                    this.snackbar("Su contraseña ha sido cambiada.")
                    this.$router.push("/login");
                }).catch(error => {
                    this.snackbar(error.body.msg || "No se pudo actualizar la contraseña");
                });
            }
        },
        mounted() {
            this.token = this.$route.params.token;
            if (this.token) {
                this.title = "Recuperación de Contraseña";
                this.validateToken();
            }
            else {
                this.title = "Cambio de Contraseña";
            }
        }
    }
</script>

<style>
    .recover {
        margin: 50px 50px;
    }
</style>
